<script>
import LuxuryPrizeWheel from "@/components/spin-preview/LuxuryPrizeWheel.vue";

const previewPrizes = [
  {
    id: "p3-a",
    amount: 3,
    unit: "Coin",
    color: "#b00035",
    textColor: "#fff9ed"
  },
  {
    id: "p5-a",
    amount: 5,
    unit: "Coin",
    color: "#f5f3ef",
    textColor: "#3d3e43"
  },
  {
    id: "p7",
    amount: 7,
    unit: "Coin",
    color: "#92002d",
    textColor: "#fff9ed"
  },
  {
    id: "p10-a",
    amount: 10,
    unit: "Coin",
    color: "#f5f3ef",
    textColor: "#3d3e43"
  },
  {
    id: "p3-b",
    amount: 3,
    unit: "Coin",
    color: "#c0063f",
    textColor: "#fff9ed"
  },
  {
    id: "p30",
    amount: 30,
    unit: "Coin",
    color: "#f5f3ef",
    textColor: "#3d3e43"
  },
  {
    id: "p5-b",
    amount: 5,
    unit: "Coin",
    color: "#a40033",
    textColor: "#fff9ed"
  },
  {
    id: "p10-b",
    amount: 10,
    unit: "Coin",
    color: "#f5f3ef",
    textColor: "#3d3e43"
  },
  {
    id: "p50",
    amount: 50,
    unit: "Coin",
    color: "#b7003a",
    textColor: "#fff1bd",
    featured: true
  },
  {
    id: "p0",
    amount: 0,
    unit: "Coin",
    color: "#f5f3ef",
    textColor: "#3d3e43"
  }
];

export default {
  name: "SpinPreview",
  components: {
    LuxuryPrizeWheel
  },
  data() {
    return {
      prizes: previewPrizes,
      coins: 888,
      remainingSpins: 1,
      isSpinning: false,
      result: null
    };
  },
  methods: {
    handleSpinStart() {
      this.result = null;
      this.isSpinning = true;
    },
    handleSpinComplete(prize) {
      this.isSpinning = false;
      this.result = prize;
      this.remainingSpins = Math.max(0, this.remainingSpins - 1);
      this.coins += prize.amount;
    },
    tryAgain() {
      this.result = null;
      this.remainingSpins = 1;
    }
  }
};
</script>

<template>
  <main class="spin-preview">
    <div class="spin-preview__noise"></div>
    <div class="spin-preview__glow spin-preview__glow--left"></div>
    <div class="spin-preview__glow spin-preview__glow--right"></div>

    <header class="preview-header">
      <div class="brand">
        <img
          class="brand__mark"
          src="../assets/images/logo2.png"
          alt="UFAEASY 888"
        />
        <div class="brand__copy">
          <span>UFAEASY 888</span>
          <strong>ROYAL REWARDS</strong>
        </div>
      </div>

      <div class="balance-pill" aria-label="ยอด Coin คงเหลือ">
        <span class="balance-pill__coin">
          <img src="../assets/images/coin.png" alt="" />
        </span>
        <span class="balance-pill__copy">
          <small>Coin ของคุณ</small>
          <strong>{{ coins.toLocaleString() }}</strong>
        </span>
      </div>
    </header>

    <section class="hero-copy">
      <div class="hero-copy__eyebrow">
        <span></span>
        <p>EXCLUSIVE MEMBER PRIVILEGE</p>
        <span></span>
      </div>
      <h1>วงล้อ<span>มหาเฮง</span></h1>
      <p>หมุนรับโชค ลุ้นรางวัลพิเศษสำหรับสมาชิกคนสำคัญ</p>
    </section>

    <section class="spin-card">
      <div class="spin-card__topline">
        <div>
          <small>สิทธิ์ประจำวัน</small>
          <strong>
            <span>{{ remainingSpins }}</span>
            / 1 ครั้ง
          </strong>
        </div>
        <p :class="{ 'spin-card__status--active': isSpinning }">
          <span></span>
          {{ isSpinning ? "กำลังหมุน" : "พร้อมลุ้นรางวัล" }}
        </p>
      </div>

      <LuxuryPrizeWheel
        :prizes="prizes"
        :remaining-spins="remainingSpins"
        @spin-start="handleSpinStart"
        @spin-complete="handleSpinComplete"
      />
    </section>

    <transition name="result">
      <div v-if="result" class="result-overlay" role="dialog" aria-modal="true">
        <section class="result-sheet">
          <div class="result-sheet__spark result-sheet__spark--one">✦</div>
          <div class="result-sheet__spark result-sheet__spark--two">✦</div>
          <div class="result-sheet__medal">
            <span>♛</span>
          </div>
          <p class="result-sheet__eyebrow">ROYAL REWARD</p>
          <h2>ยินดีด้วยค่ะ!</h2>
          <p class="result-sheet__description">คุณได้รับรางวัล</p>
          <div class="result-sheet__prize">
            <img src="../assets/images/coin.png" alt="" />
            <strong>+{{ result.amount }}</strong>
            <span>Coin</span>
          </div>
          <p class="result-sheet__note">
            Preview เท่านั้น — ยังไม่มีการบันทึกรางวัลจริง
          </p>
          <button type="button" @click="tryAgain">ลองหมุนอีกครั้ง</button>
        </section>
      </div>
    </transition>
  </main>
</template>

<style lang="scss" scoped>
.spin-preview {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  padding: calc(14px + env(safe-area-inset-top, 0px)) clamp(14px, 4vw, 24px)
    calc(28px + env(safe-area-inset-bottom, 0px));
  background: radial-gradient(
      circle at 50% 43%,
      rgba(151, 0, 43, 0.18),
      transparent 32%
    ),
    radial-gradient(circle at 92% 56%, rgba(255, 162, 34, 0.2), transparent 36%),
    radial-gradient(circle at 8% 86%, rgba(200, 124, 22, 0.16), transparent 30%),
    linear-gradient(155deg, #727378 0%, #4a4b50 42%, #222329 100%);
  color: #fff8e8;
  font-family: "Tahoma", sans-serif;
  isolation: isolate;
}

.spin-preview::before {
  content: "";
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(
      circle at 14% 20%,
      rgba(255, 225, 150, 0.62) 0 1px,
      transparent 2px
    ),
    radial-gradient(
      circle at 84% 12%,
      rgba(255, 198, 93, 0.52) 0 1px,
      transparent 2px
    ),
    linear-gradient(
      118deg,
      transparent 49.7%,
      rgba(255, 218, 149, 0.08) 50%,
      transparent 50.3%
    );
  background-size: 128px 146px, 176px 194px, 96px 160px;
  opacity: 0.78;
}

.spin-preview::after {
  content: "";
  position: absolute;
  z-index: 0;
  right: -390px;
  top: 35%;
  width: 720px;
  height: 270px;
  border: 2px solid rgba(255, 177, 60, 0.32);
  border-radius: 50%;
  pointer-events: none;
  transform: rotate(-14deg);
  box-shadow: 0 0 10px rgba(255, 171, 43, 0.52),
    0 0 0 7px rgba(255, 205, 119, 0.06), 0 0 0 20px rgba(255, 165, 35, 0.04);
}

.spin-preview__noise {
  position: fixed;
  z-index: 20;
  inset: 0;
  pointer-events: none;
  opacity: 0.035;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.7'/%3E%3C/svg%3E");
}

.spin-preview__glow {
  position: absolute;
  z-index: 1;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  filter: blur(22px);
  opacity: 0.34;
  pointer-events: none;
}

.spin-preview__glow--left {
  left: -150px;
  top: 24%;
  background: #8f002c;
}

.spin-preview__glow--right {
  right: -170px;
  top: 54%;
  background: #e29a2b;
}

.preview-header {
  position: relative;
  z-index: 4;
  display: flex;
  width: min(100%, 560px);
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  min-width: 0;
}

.brand__mark {
  width: 58px;
  height: 58px;
  object-fit: contain;
  filter: drop-shadow(0 5px 11px rgba(0, 0, 0, 0.45));
}

.brand__copy {
  display: flex;
  margin-left: -4px;
  flex-direction: column;
}

.brand__copy span {
  color: #ffe29a;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.brand__copy strong {
  margin-top: 2px;
  color: rgba(255, 241, 209, 0.65);
  font-size: 8px;
  letter-spacing: 0.24em;
}

.balance-pill {
  display: flex;
  min-width: 116px;
  padding: 6px 11px 6px 7px;
  border: 1px solid rgba(255, 212, 123, 0.48);
  border-radius: 999px;
  align-items: center;
  background: linear-gradient(
    145deg,
    rgba(255, 247, 218, 0.15),
    rgba(39, 39, 43, 0.72)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18),
    0 7px 21px rgba(0, 0, 0, 0.3), 0 0 16px rgba(244, 164, 44, 0.09);
  backdrop-filter: blur(12px);
}

.balance-pill__coin {
  display: grid;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  place-items: center;
  background: radial-gradient(circle, #efcf77, #9d661a);
  box-shadow: 0 0 10px rgba(230, 181, 79, 0.26);
}

.balance-pill__coin img {
  width: 27px;
  height: 27px;
  object-fit: contain;
}

.balance-pill__copy {
  display: flex;
  margin-left: 8px;
  flex-direction: column;
}

.balance-pill__copy small {
  color: rgba(255, 242, 215, 0.68);
  font-size: 8px;
}

.balance-pill__copy strong {
  margin-top: 1px;
  color: #ffe89e;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 17px;
  line-height: 1;
}

.hero-copy {
  position: relative;
  z-index: 2;
  margin: clamp(13px, 3.5vh, 30px) auto clamp(10px, 2vh, 18px);
  text-align: center;
}

.hero-copy__eyebrow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.hero-copy__eyebrow span {
  width: 28px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #d2a84d);
}

.hero-copy__eyebrow span:last-child {
  transform: rotate(180deg);
}

.hero-copy__eyebrow p {
  color: #ffd787;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(8px, 2.2vw, 10px);
  letter-spacing: 0.18em;
}

.hero-copy h1 {
  margin: 5px 0 2px;
  font-family: Georgia, "Times New Roman", "Tahoma", serif;
  font-size: clamp(31px, 8.2vw, 48px);
  font-weight: 400;
  line-height: 1.06;
  letter-spacing: -0.04em;
  text-shadow: 0 5px 22px rgba(0, 0, 0, 0.5);
}

.hero-copy h1 span {
  margin-left: 8px;
  background: linear-gradient(180deg, #fff4c8 10%, #ffbd3f 52%, #d97808 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 700;
}

.hero-copy > p {
  color: rgba(255, 249, 231, 0.74);
  font-size: clamp(11px, 3vw, 13px);
}

.spin-card {
  position: relative;
  z-index: 2;
  width: min(100%, 520px);
  margin: 0 auto;
  padding: 13px 11px 20px;
  border: 1px solid rgba(255, 208, 112, 0.34);
  border-radius: 26px;
  background: linear-gradient(
      150deg,
      rgba(255, 255, 255, 0.07),
      transparent 32%
    ),
    linear-gradient(180deg, rgba(70, 70, 75, 0.76), rgba(29, 29, 34, 0.9));
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.14), 0 0 34px rgba(183, 0, 55, 0.08);
  backdrop-filter: blur(8px);
}

.spin-card::before {
  content: "";
  position: absolute;
  inset: 5px;
  border: 1px solid rgba(255, 232, 178, 0.11);
  border-radius: 21px;
  pointer-events: none;
}

.spin-card__topline {
  position: relative;
  z-index: 3;
  display: flex;
  margin: 0 8px 12px;
  align-items: flex-end;
  justify-content: space-between;
}

.spin-card__topline > div {
  display: flex;
  flex-direction: column;
}

.spin-card__topline small {
  color: rgba(255, 241, 213, 0.6);
  font-size: 9px;
}

.spin-card__topline strong {
  margin-top: 2px;
  color: #f4e3bd;
  font-size: 12px;
}

.spin-card__topline strong span {
  color: #ffe694;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 20px;
}

.spin-card__topline > p {
  display: flex;
  padding-bottom: 3px;
  align-items: center;
  gap: 6px;
  color: rgba(255, 242, 215, 0.7);
  font-size: 10px;
}

.spin-card__topline > p span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffbd4b;
  box-shadow: 0 0 9px rgba(255, 173, 42, 0.9);
}

.spin-card__status--active span {
  animation: statusPulse 0.7s ease-in-out infinite alternate;
}

.result-overlay {
  position: fixed;
  z-index: 10000;
  inset: 0;
  display: flex;
  padding: 18px;
  align-items: center;
  justify-content: center;
  background: rgba(19, 19, 23, 0.8);
  backdrop-filter: blur(9px);
}

.result-sheet {
  position: relative;
  width: min(100%, 360px);
  overflow: hidden;
  padding: 30px 24px 24px;
  border: 1px solid rgba(255, 225, 149, 0.36);
  border-radius: 28px;
  background: radial-gradient(
      circle at 50% 15%,
      rgba(223, 177, 74, 0.18),
      transparent 37%
    ),
    linear-gradient(155deg, #4d4d52, #242429 64%, #410016);
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.65),
    inset 0 1px 0 rgba(255, 255, 255, 0.14);
  text-align: center;
}

.result-sheet::before {
  content: "";
  position: absolute;
  inset: 8px;
  border: 1px solid rgba(247, 220, 153, 0.1);
  border-radius: 21px;
  pointer-events: none;
}

.result-sheet__medal {
  display: grid;
  width: 62px;
  height: 62px;
  margin: 0 auto 16px;
  border: 2px solid #e9bb57;
  border-radius: 50%;
  place-items: center;
  background: radial-gradient(circle at 35% 28%, #fff0ad, #d49329 55%, #75400c);
  color: #60320a;
  box-shadow: 0 0 0 5px #563009, 0 0 30px rgba(230, 179, 68, 0.42);
}

.result-sheet__medal span {
  font-size: 27px;
}

.result-sheet__eyebrow {
  color: #d9b45f;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.25em;
}

.result-sheet h2 {
  margin-top: 5px;
  color: #fff1c4;
  font-family: Georgia, "Times New Roman", "Tahoma", serif;
  font-size: 30px;
}

.result-sheet__description {
  margin-top: 3px;
  color: rgba(240, 229, 200, 0.58);
  font-size: 12px;
}

.result-sheet__prize {
  display: flex;
  margin: 18px 0 13px;
  align-items: center;
  justify-content: center;
}

.result-sheet__prize img {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.result-sheet__prize strong {
  margin-left: 8px;
  color: #ffe68e;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 48px;
  line-height: 1;
}

.result-sheet__prize span {
  margin: 13px 0 0 6px;
  color: #e9d49d;
  font-size: 12px;
}

.result-sheet__note {
  color: rgba(238, 225, 192, 0.44);
  font-size: 9px;
}

.result-sheet button {
  position: relative;
  width: 100%;
  margin-top: 20px;
  padding: 12px 18px;
  border: 1px solid #efcd77;
  border-radius: 999px;
  background: linear-gradient(180deg, #f9de90, #bd7e22);
  color: #4b2707;
  font-weight: 700;
  box-shadow: 0 7px 20px rgba(188, 125, 32, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.65);
}

.result-sheet__spark {
  position: absolute;
  color: #f6d474;
  animation: sparkFloat 1.8s ease-in-out infinite alternate;
}

.result-sheet__spark--one {
  left: 18%;
  top: 13%;
}

.result-sheet__spark--two {
  right: 17%;
  top: 24%;
  animation-delay: -0.8s;
}

.result-enter-active,
.result-leave-active {
  transition: opacity 240ms ease;
}

.result-enter-active .result-sheet,
.result-leave-active .result-sheet {
  transition: transform 320ms cubic-bezier(0.2, 0.9, 0.3, 1);
}

.result-enter,
.result-leave-to {
  opacity: 0;
}

.result-enter .result-sheet,
.result-leave-to .result-sheet {
  transform: translateY(20px) scale(0.95);
}

@keyframes statusPulse {
  from {
    opacity: 0.45;
    transform: scale(0.78);
  }
  to {
    opacity: 1;
    transform: scale(1.08);
  }
}

@keyframes sparkFloat {
  from {
    opacity: 0.4;
    transform: translateY(4px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(-4px) scale(1.12);
  }
}

@media (min-width: 680px) {
  .spin-preview {
    padding-bottom: 42px;
  }
}

@media (max-height: 730px) {
  .hero-copy {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .hero-copy h1 {
    font-size: clamp(28px, 7.5vw, 38px);
  }

  .spin-card {
    padding-bottom: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .spin-card__status--active span,
  .result-sheet__spark {
    animation: none;
  }
}
</style>
